<template>
  <!-- implémentation personnalisé du datePicker,  -->
  <span>
    <datepicker
      ref="datePicker"
      v-model="inputDate"
      :bootstrap-styling="true"
      :calendar-button="true"
      :clear-button="clearButton"
      :format="customFormatter"
      :language="fr"
      calendar-button-icon="fa fa-calendar"
      class="dateStyle"
      clear-button-icon="fa fa-times"
      @input="$emit('input', customFormatter(inputDate))"
    ></datepicker>
  </span>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import * as moment from "moment";
import { fr } from "vuejs-datepicker/dist/locale";

export default {
  name: "DatePicker",
  props: ["value", "clearButton"],
  components: {
    Datepicker,
  },
  data() {
    return {
      inputDate: null,
      fr: fr,
      dateRegex: RegExp(
        "^(0[1-9]|[12][0-9]|3[01])[- /.](?:(0[1-9]|1[012])[- /.](19|20)[0-9]{2})$"
      ),
    };
  },
  watch: {
    value(val) {
      if (val && this.dateRegex.test(val)) {
        this.inputDate = moment(val, "DD/MM/YYYY").toDate();
      } else {
        this.inputDate = null;
      }
    },
  },
  methods: {
    customFormatter(date) {
      var dateToReturn = moment(date).format("DD/MM/YYYY");
      if (dateToReturn && !this.dateRegex.test(dateToReturn)) {
        dateToReturn = null;
      }
      return dateToReturn;
    },
  },
};
</script>

<style>
@import "https://use.fontawesome.com/releases/v5.3.1/css/all.css";

.form-control {
  border-color: #28a745;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: white;
}

.form-control:focus {
  box-shadow: 0 0 0 0.2rem #28a7462d;
  border-color: #28a745;
  border-top-color: rgb(40, 167, 69);
  border-right-color: rgb(40, 167, 69);
  border-bottom-color: rgb(40, 167, 69);
  border-left-color: rgb(40, 167, 69);
}
</style>
